import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore , addDoc, setDoc, getDocs, collection, doc, getDoc, deleteDoc } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { fbase } from "./config"

// Initialize Firebase
const app = initializeApp(fbase);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Storage
export const cloudStorage = getStorage( app )

export const db = getFirestore( app )

export const writeGalleryEntry = async ( title , description , url , collection ) => {
    const docID = `${title.replace(" ","")}-${collection.replace(" ","")}`.toLowerCase()
    const ref = doc( db , "photos" , docID)
    const data = {
        "title": title,
        "description": description,
        "url": url,
        "collection":collection,
    }
    
    try { 
        await setDoc( ref , data)   
        console.log("Document inserted successfully")
    } catch ( err ) { 
        console.error(" Failed to insert new photo to gallery ")
    }
}


export const getGalleryEntries = async ( ) => { 
    const entries = [];
    const snap = await getDocs( collection(db,"photos"))
    snap.forEach( doc => { 
        const fields = { ...doc.data()}
        entries.push({ "id": doc.id , ...fields})

    })

    return entries;
}

export const createMessage = async ( contactName, contactEmail , subject , message ) => { 
    const docID = `${contactName.toLowerCase()}-${Date.now()}`
    const ref = doc(db , "messages", docID)
    const data = {
        "contactName": contactName,
        "contactEmail": contactEmail,
        "subject": subject,
        "message": message, 
        "sent": new Date().toUTCString(),
        "read": false,
    }
    try {
        await setDoc(ref, data)
        console.log("Message Sent Successfully")
        return true
    } catch (error) {
        console.warn("Failed to create a message...")
        console.error(error)
    }
    
}


export const getMessages = async ( ) => { 
    const messages = [] 
    const snap = await getDocs( collection(db,"messages"))
    snap.forEach( doc => {
        const fields = {...doc.data()}
        messages.push( {id: doc.id, ...fields} )

    })
    console.log(messages)
    return messages
}

export const deleteMessage = async ( id ) => { 
    
    try {
        const ref = doc(db,"messages",id)
        await deleteDoc(ref)
        console.log("Message deleted successfully")
    } catch (error) {
        console.warn("Failed to delete message")
        console.error(error)
    }
}


export const setAbout = async ( text ) => { 
    const docID = 'about_text'
    const ref = doc(db,"cms",docID)
    const data = {"text":text}
    try {
        await setDoc(ref, data)
        console.log("success!")
    } catch (error) {
        console.warn("failed to set about")
        console.error(error)
    }

}


export const getAboutText = async ( ) => {  
    const ref = doc( db , "cms", "about_text")
    const snap = await getDoc( ref )
    if( snap.exists() ){
        const text = snap.data()
        return text
    }
}
